<template>
  <div id="app">
    <div class="btns">
      <span v-for="item in buttonList" :key="item.url" style="margin-right: 20px">
        <router-link :to="item.url">{{ item.text }}</router-link>
      </span>
    </div>
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {
      buttonList: [
        { text: '图', url: '/GraphView' },
        { text: 'svg', url: '/SvgView' }
      ]
    }
  }
}
</script>
<style lang="less">
* {
  margin: 0;
  padding: 0;
}
html {
  overflow: auto; /* 或 overflow: scroll; */
  scrollbar-gutter: stable; /* 直接作用于 html */
}
#app {
  height: 100vh;
  width: 100vw;
}
.btns {
  position: fixed;
  top: 0;
  width: 100%;
  height: 3vh;
  display: flex;
  justify-content: center;
  z-index: 9999;
  a {
    text-decoration: none;
    color: #6495ed;
  }
}
</style>
